import { DadosBancario } from "@/Models/Pessoa/DadosBancario";
import { Axios } from "@/Services/Axios";
import { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useDadosBancarioListarPorPessoa({
    codPessoa,
    ...rest
}:QueryBasicaParam<AxiosResponse<DadosBancario[]>, DadosBancario[], {
    codPessoa:number
}>) {

    return useQuery({
        ...rest,
        queryKey : ["Pessoa", "DadosBancario", "ListarPorPessoa", codPessoa ],
        queryFn : () => Axios.get<DadosBancario[]>(`pessoa/dadosBancario/pessoa/${codPessoa}`),
        staleTime : 1000 * 60 * 0.5,
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                return m;
            });
        },
    });
}